import { BankOutlined } from "@ant-design/icons";
import { Badge, Divider } from "antd";
import { displayNumbers } from "../../../variables/numbersFunctions";

// Composant pour le header d'un panel compagnie
export const CompagniePanelHeader = ({ compagnie, totalItems, totalOriginal, totalRetrocede, type }) => {
    const getTypeColor = () => {
        switch (type) {
            case 'emissions': return '#52c41a';
            case 'annulations': return '#faad14';
            case 'sinistres': return '#ff4d4f';
            case 'recours': return '#13c2c2';
            default: return '#1890ff';
        }
    };

    return (
        <div className="compagnie-panel-header">
            <div className="header-left">
                <BankOutlined style={{ fontSize: 18, color: getTypeColor(), marginRight: 12 }} />
                <div className="compagnie-info">
                    <span className="compagnie-name">{compagnie.raisonSociale}</span>
                    <span className="compagnie-code">{compagnie.code}</span>
                </div>
            </div>
            <div className="header-right">
                <div className="stat-item">
                    <span className="stat-label">Éléments</span>
                    <Badge count={totalItems} showZero style={{ backgroundColor: getTypeColor() }} />
                </div>
                <Divider type="vertical" style={{ height: 32 }} />
                <div className="stat-item">
                    <span className="stat-label">Montant Total</span>
                    <span className="stat-value">{displayNumbers(totalOriginal)} F</span>
                </div>
                {/* <Divider type="vertical" style={{ height: 32 }} />
                <div className="stat-item highlight">
                    <span className="stat-label">Rétrocédé</span>
                    <span className="stat-value" style={{ color: getTypeColor() }}>
                        {displayNumbers(totalRetrocede)} F
                    </span>
                </div> */}
            </div>
        </div>
    );
};